/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpageloaderror3Inputs */

const en_ticketpageloaderror3 = /** @type {(inputs: Ticketpageloaderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The tickets could not be loaded.`)
};

const de_ticketpageloaderror3 = /** @type {(inputs: Ticketpageloaderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Tickets konnten nicht geladen werden.`)
};

/**
* | output |
* | --- |
* | "The tickets could not be loaded." |
*
* @param {Ticketpageloaderror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpageloaderror3 = /** @type {((inputs?: Ticketpageloaderror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpageloaderror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpageloaderror3(inputs)
	return de_ticketpageloaderror3(inputs)
});
export { ticketpageloaderror3 as "ticketPageLoadError" }